import React, { useState, useEffect, useCallback } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import Modal from "../../../components/UI/Modal/Modal";
import { combineArrs, getInputDateFromTime } from "../../../store/utility";
import md5 from "md5";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Joi from "joi";
import QuillEditor from "../../../components/UI/QuillEditor/QuillEditor";
// import Spinner from "../../../components/Spinner/Spinner";
import { timestamp } from "../../../firebase/index";
import DynamicKeyValue from "../../../components/UI/DynamicKeyValue/DynamicKeyValue";
const VariableProduct = (props) => {
  const [inputVarProduct, setVarProduct] = useState({
    productTitle: "",
    productDesc: "",
    // productImgUrl: "",
    categoryId: "",
    subcategoryId: "",
    productTypeId: "",
    brand: "",
    brandId: "",
    salePrice: null,
    regularPrice: null,
    variable: false,
    previewImages: [],
    stock: null,
  });
  const [savedAttributes, setSavedAttributes] = useState({});
  const [attributeList, setAttributeList] = useState([]);
  const [attributeArray, setAttributeArray] = useState([]);
  const [selectedAttribute, setAttribute] = useState("");
  const [showVariantModal, setVariantModal] = useState(false);
  const [variants, setVariants] = useState([]);
  const [combinations, setCombinations] = useState([]);
  const [selectedCombinations, setVariantSelect] = useState([]);
  const [isEveryAttrSelected, setEveryAttrSelected] = useState(false);

  useEffect(() => {
    props.fetchAttribute();
    //Edit Product-------------------
    if (props.isEdit) {
      setEveryAttrSelected(true);
    }
    window.onbeforeunload = function () {
      return "Dude, are you sure you want to leave? Think of the kittens!";
    };
  }, []);

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;
    setVarProduct({ ...inputVarProduct, [name]: value });
  });

  const setVariantInputValue = (type, variantId, name, value) => {
    let item = null;
    if (type == "variants") {
      if (!isNaN(parseInt(value))) {
        value = parseInt(value);
      }
      if (name == "stock") {
        let variableStock = props.product.variableStock;
        if (variableStock) {
          variableStock[variantId] = value;
        } else {
          variableStock = {};
          variableStock[variantId] = value;
        }
        props.setProduct({
          ...props.product,
          variants: variants,
          variableStock: variableStock,
        });
      }
      if (name == "expiry") {
        let variantExpiries = [];
        variantExpiries.push(value);
        if (variants.length) {
          variants.map((variant) => {
            if (variant.expiry && variant.variantId != variantId) {
              variantExpiries.push(variant.expiry);
            }
          });
        }
        props.setProduct({
          ...props.product,
          variants: variants,
          expiry: Math.min(...variantExpiries),
        });
      }
      let variantsArr = variants.concat();
      item = variantsArr.filter((vObj) => vObj.variantId == variantId)[0];
      if (item) {
        item[name] = value;
        setVariants(variantsArr);
      } else {
        return "";
      }
    }
  };
  const getVariantInputValue = (type, variantId, name) => {
    let item = null;
    if (type == "variants") {
      item = variants.filter((vObj) => vObj.variantId == variantId)[0];
    }
    // else if(type=="combinations"){
    //   item = combinations.filter(vObj=>vObj.variantId==variantId)[0];
    // }else{
    //   return ""
    // }

    if (item) {
      if (name == "stock") {
        let variableStock = props.product.variableStock;
        if (variableStock) {
          return variableStock[variantId] ? variableStock[variantId] : 0;
        }
      } else {
        return item[name] ? item[name] : "";
      }
    } else {
      return "";
    }
  };

  const handleSelectAttribute = (e) => {
    setAttribute(e.target.value);
    // console.log(selectedAttribute);
  };
  const handleAddAttribute = (e) => {
    e.preventDefault();
    setEveryAttrSelected(false);
    if (variants.length) {
      return alert("Now you cannot add more attributes..");
    }
    let singleAttribute = selectedAttribute;
    if (attributeArray.includes(singleAttribute)) {
      alert("Attribute already added!");
    } else {
      attributeArray.push(singleAttribute);
      // console.log(attributeArray);
      let attributeObject = props.attributes.filter(
        (attribute) => attribute.id == singleAttribute
      )[0];
      let newAttributeList = [...attributeList, attributeObject];
      // console.log(newAttributeList)
      setAttributeList(newAttributeList);
    }
  };

  const handleValueCheck = (e, name, attributeId, value) => {
    let checkBoxId = e.target.id;
    let attributeValue = value;
    // console.log(attributeId)
    name = name.toLowerCase();
    let checked = document.getElementById(checkBoxId).checked;

    // console.log(name, attributeValue, checked);
    let newSavedAttrs = { ...savedAttributes };
    if (newSavedAttrs[attributeId]) {
      //Has attribute
      let attrValues = newSavedAttrs[attributeId];
      if (checked) {
        newSavedAttrs[attributeId] = [
          ...attrValues,
          { id: attributeId, value, attribute: name },
        ];
      } else {
        newSavedAttrs[attributeId] = attrValues.filter(
          (val) => val.value !== value
        );
        if (!newSavedAttrs[attributeId].length) {
          delete newSavedAttrs[attributeId];
        }
      }
    } else {
      if (checked) {
        newSavedAttrs[attributeId] = [
          { id: attributeId, value, attribute: name },
        ];
      }
    }

    setSavedAttributes(newSavedAttrs);
  };

  const combinationSelect = (e, variantId) => {
    let checkedVariants = selectedCombinations.concat();
    let checked = e.target.checked;
    if (checked) {
      checkedVariants.push(variantId);
      setVariantSelect(checkedVariants);
    } else {
      const index = checkedVariants.indexOf(variantId);
      if (index > -1) {
        checkedVariants.splice(index, 1);
      }
      setVariantSelect(checkedVariants);
    }
  };
  const handleCombinationSave = () => {
    let combination = combinations.concat();
    let variantS = variants ? variants.concat() : [];

    //Remove duplicate elements
    combination.map((obj) => {
      if (selectedCombinations.includes(obj.variantId)) {
        // obj.selected = true;
        variantS.push(obj);
        combination = combination.filter((c) => c.variantId != obj.variantId);
      }
    });
    setVariants(variantS);
    setCombinations(combination);
    setVariantSelect([]);
    setVariantModal(false);
  };
  const handleSaveAttribute = () => {
    // console.log(attributeArray,savedAttributes)

    let flag = false;
    for (let i = 0; i < attributeArray.length; i++) {
      let attrid = attributeArray[i];
      if (!savedAttributes[attrid]) {
        flag = true; // All attribute not selected.
        break;
      }
    }

    if (flag) {
      alert("Please Select All Attributes");
      return false;
    } else {
      //All attribute is selected.
      setEveryAttrSelected(true);
      return true;
    }
  };

  const handleVariantTab = (e) => {
    if (!handleSaveAttribute()) {
      return false;
    }

    if (props.product) {
      let _variants = variants;
      // let productvariants  = props.product.variants;
      // if(productvariants){
      //  // alert("Product Variants already present")
      //   _variants.concat(productvariants, _variants);
      //   setVariants(_variants);
      // }
      //setVariants(variants?productvariants:[]);
      let combinations = combineArrs(Object.values(savedAttributes));

      if (combinations) {
        let filterComb = combinations.filter((cObj) => {
          let exists = _variants.filter(
            (vObj) => cObj.variantId == vObj.variantId
          ).length;
          if (exists) {
            return false;
          } else {
            return true;
          }
        });
        let uniqueFilterComb = filterComb.filter(
          (v, i, a) => a.findIndex((t) => t.variantId === v.variantId) === i
        );

        //Solving single attribute in combinations even if it has more than one attributes.
        //Temporary Solution
        if (props.isEdit) {
          for (let i = 0; i < uniqueFilterComb.length; i++) {
            let fobj = uniqueFilterComb[i];
            if (Object.keys(fobj.attributes).length != attributeList.length) {
              return alert("Please select values from every attributes");
            }
          }
        }

        // console.log("Filtered Combination",filterComb);
        //
        setCombinations(uniqueFilterComb ? uniqueFilterComb : []);
      }

      // else{
      //   console.log("Combinations",combinations)
      //   setCombinations(combinations?combinations:[]);
      // }
    }
  };

  const createCombinationName = (attributes) => {
    let attributeName = "";
    for (let attrKey in attributes) {
      let attribute = attributes[attrKey];
      attributeName += attribute.name + " ";
    }
    return attributeName;
  };

  const getAccordions = () => {
    if (variants) {
      if (variants.length > 0) {
        let accordion = (
          <Accordion defaultActiveKey="0">
            {variants.map((vObj, index) => (
              <Card>
                <Accordion.Toggle as={Card.Header} eventKey={index.toString()}>
                  {createCombinationName(vObj.attributes)}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={index.toString()}>
                  <Card.Body>
                    <form key={"form" + index}>
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label for={"inputTitle" + index}>Title</label>
                          <input
                            required
                            name="productTitle"
                            type="text"
                            className="form-control"
                            id={"inputTitle" + index}
                            placeholder="Title"
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "productTitle"
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "productTitle",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div className="form-group col">
                          <label for={"inputStock" + index}>Stock</label>
                          <input
                            name="stock"
                            required
                            min={1}
                            type="number"
                            className="form-control"
                            id={"inputStock" + index}
                            placeholder="Enter Stock"
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "stock"
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "stock",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div className="form-group col">
                          <label for={"inputExpiry" + index}>Expiry</label>
                          <input
                            name="expiry"
                            type="date"
                            className="form-control"
                            id={"inputExpiry" + index}
                            placeholder="Expiry (Optional)"
                            value={getInputDateFromTime(
                              getVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "expiry"
                              )
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "expiry",
                                new Date(e.target.value).getTime()
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label for={"prodDesc" + index}>Description</label>

                          <QuillEditor
                            toolbar={true}
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "productDesc"
                            )}
                            setValue={(value) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "productDesc",
                                value
                              )
                            }
                          />
                        </div>

                        <div className="form-group col-md-6">
                          <label for={"keyFeatures" + index}>
                            Key Features
                          </label>

                          <QuillEditor
                            toolbar={true}
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "keyFeatures"
                            )}
                            setValue={(value) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "keyFeatures",
                                value
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col-md-3">
                          <label for={"salePriceIp" + index}>
                            Selling Price
                          </label>
                          <input
                            name="salePrice"
                            min={1}
                            required
                            type="number"
                            className="form-control"
                            id={"salePriceIp" + index}
                            placeholder="Enter SP"
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "salePrice"
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "salePrice",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="form-group col-md-3">
                          <label for={"regPriceIP" + index}>
                            Regular Price
                          </label>
                          <input
                            name="regularPrice"
                            min={1}
                            required
                            type="number"
                            className="form-control"
                            id={"regPriceIP" + index}
                            placeholder="Enter RP"
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "regularPrice"
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "regularPrice",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div className="form-group col-md-3">
                          <label for="inputWeight">Weight (in grams)</label>
                          <input
                            name="weight"
                            min={1}
                            required
                            type="number"
                            className="form-control"
                            id={`inputWeight${index}`}
                            placeholder="Weight in gms"
                            value={getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "weight"
                            )}
                            onChange={(e) =>
                              setVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "weight",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div className="form-group col-md-3 align-self-end">
                          <button
                            type="button"
                            className="btn btn-info btn-sm form-control"
                            onClick={() =>
                              props.switchToPreviewModal(
                                variants.filter(
                                  (v) => v.variantId == vObj.variantId
                                )[0]
                              )
                            }
                          >
                            Add Images
                          </button>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group col text-center">
                          <label>Preview Images</label>
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              border: "1px solid grey",
                              borderRadius: "4px",
                              display: "flex",
                              overflowY: "auto",
                            }}
                          >
                            {getVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "previewImages"
                            ) &&
                              getVariantInputValue(
                                "variants",
                                vObj.variantId,
                                "previewImages"
                              ).map((image) => (
                                <div className="m-3 d-flex">
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "18px",
                                    }}
                                    onClick={() => {
                                      let updatedVariant =
                                        props.removePreviewImages(
                                          image,
                                          vObj.variantId,
                                          variants
                                        );
                                      setVariantInputValue(
                                        "variants",
                                        updatedVariant.variantId,
                                        "previewImages",
                                        updatedVariant.previewImages
                                      );
                                    }}
                                  >
                                    <i
                                      className="fa fa-times"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                  <img
                                    src={image}
                                    alt={image}
                                    style={{ width: "150px", height: "150px" }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <DynamicKeyValue
                          dataObj={getVariantInputValue(
                            "variants",
                            vObj.variantId,
                            "additionalInfo"
                          )}
                          setDataObj={(data) =>
                            setVariantInputValue(
                              "variants",
                              vObj.variantId,
                              "additionalInfo",
                              data
                            )
                          }
                        />
                      </div>
                    </form>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            ))}
          </Accordion>
        );

        return accordion;
      }
    } else {
      return null;
    }
  };

  const variantSchema = Joi.object({
    id: Joi.string().required(),
    variantId: Joi.string().required(),
    attributes: Joi.object(),
    previewImages: Joi.array().min(1).required(),
    productDesc: Joi.string().required(),
    productTitle: Joi.string().required(),
    regularPrice: Joi.number().min(1).required(),
    salePrice: Joi.number().min(1).required(),
    stock: Joi.optional(),
    weight: Joi.number().min(1).required(),
    timestamp: Joi.optional(),
    keyFeatures: Joi.optional(),
    additionalInfo: Joi.object().optional(),
    expiry: Joi.optional(),
  });

  const commonSchema = Joi.object({
    id: Joi.string().required(),
    rating: Joi.optional(),
    reviewCount: Joi.optional(),
    variants: Joi.optional(),
    productDesc: Joi.string().required(),
    productTitle: Joi.string().required(),
    categoryId: Joi.string().required(),
    categoryName: Joi.string().max(50).required(),
    subcategoryId: Joi.string().required(),
    subcategoryName: Joi.string().max(50).required(),
    brand: Joi.string().max(50).required(),
    brandId: Joi.string().required(),
    productTypeId: Joi.string().required(),
    variable: Joi.boolean().required(),
    variableStock: Joi.object().required(),
    regularPrice: Joi.optional(),
    salePrice: Joi.optional(),
    stock: Joi.optional(),
    weight: Joi.optional(),
    previewImages: Joi.optional(),
    searchSpace: Joi.optional(),
    timestamp: Joi.optional(),
    someStockOut: Joi.optional(),
    keyFeatures: Joi.optional(),
    additionalInfo: Joi.object().optional(),
    expiry: Joi.optional(),
    filters: Joi.optional(),
    gender: Joi.array(),
  });

  const handleSubmitProduct = () => {
    //  console.log(variants)
    if (!variants.length) {
      return alert("A Variable Product must have atleast one variant");
    }

    let product = { ...props.product, variants: [...variants] };

    if (!product.id) {
      product["id"] = md5(md5(product) + Math.random() * 1000000000);
    }
    if (!product.timestamp) {
      product["timestamp"] = timestamp.now().seconds * 1000;
    }
    product.variants.map((vObj) => {
      vObj.id = product.id;
      vObj.timestamp = timestamp.now().seconds * 1000;
    });
    let e = false;
    for (let i = 0; i < variants.length; i++) {
      let variant = variants[i];
      // console.log(variant);
      // console.log(variant)
      let { error } = variantSchema.validate(variant);
      if (error) {
        e = error;
        break;
      }
    }
    if (e) {
      return alert(e);
    }
    console.log("Passed Variant Check");
    let { error } = commonSchema.validate(product);
    if (error) {
      return alert(error);
    }
    console.log("Passed Common Schema");

    props.onAddSingleProduct(product);
  };

  useEffect(() => {
    try {
      if (props.product && props.attributes && props.isEdit) {
        let product = props.product;
        let _variants = props.product.variants;

        if (variants.length) {
          _variants.concat(variants);
        }

        //Setting Existing Attributes

        //Setting attributeList

        let varIds = Object.keys(product.variants[0].attributes);

        let attributeObject = props.attributes.filter((attribute) => {
          if (varIds.includes(attribute.id)) {
            return true;
          }
        });
        // let newAttributeList = [...attributeList, attributeObject];
        // console.log(attributeObject)
        setAttributeList(attributeObject);

        //Setting savedAttributes
        let savedAttributes = {};
        _variants.map((vObj) => {
          let attributes = vObj.attributes;
          for (let attrKey in attributes) {
            let attribute = attributes[attrKey];
            if (savedAttributes[attrKey]) {
              savedAttributes[attrKey] = [
                ...savedAttributes[attrKey],
                attribute,
              ];
            } else {
              savedAttributes[attrKey] = [attribute];
            }
          }
        });
        // console.log(savedAttributes);
        setSavedAttributes(savedAttributes);

        // Setting Variant

        setVariants(_variants);
      }
    } catch (error) {}
  }, [props.product, props.attributes]);
  useEffect(() => {
    if (props.variant) {
      //Currenlty this method is made to update variant perviewImages coming from addProduct component.
      //And variant is being set in addProduct using switchToPreviewModal method.
      let variant = props.variant;
      // console.log(props.variant)
      setVariantInputValue(
        "variants",
        variant.variantId,
        "previewImages",
        variant.previewImages
      );
    }
  }, [props.variant]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-3">
          <div
            className="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              className="nav-link active"
              id="v-pills-home-tab"
              data-toggle="pill"
              href="#v-pills-home"
              role="tab"
              aria-controls="v-pills-home"
              aria-selected="true"
            >
              Attributes
            </a>

            <a
              className="nav-link"
              id="v-pills-profile-tab"
              data-toggle="pill"
              href="#v-pills-profile"
              role="tab"
              aria-controls="v-pills-profile"
              aria-selected="false"
              onClick={handleVariantTab}
              style={{
                pointerEvents: isEveryAttrSelected ? "visible" : "none",
              }}
            >
              Variations
            </a>
          </div>
        </div>
        <div className="col-9">
          <div className="tab-content" id="v-pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="v-pills-home"
              role="tabpanel"
              aria-labelledby="v-pills-home-tab"
            >
              {/* ------------------- Select Attribute starts ----------------------*/}
              <form>
                {!props.isEdit && (
                  <div className="form-row align-items-center">
                    <div className="col-auto my-1">
                      <select
                        name="selectedAttribute"
                        className="custom-select mr-sm-2"
                        id="inlineFormCustomSelect"
                        onChange={handleSelectAttribute}
                      >
                        <option value="" selected>
                          Select Attribute to Add...
                        </option>
                        {props.attributes &&
                          props.attributes.map((attribute, index) => (
                            <option key={index} value={attribute.id}>
                              {attribute.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <button
                      className="btn btn-success btn-sm mx-2"
                      onClick={handleAddAttribute}
                    >
                      Add
                    </button>
                  </div>
                )}
              </form>
              <hr />
              {/* ------------------- Select Attribute ends ----------------------*/}
              {/* ------------------- Select Attribute Value Starts ----------------------*/}
              <table class="table table-sm">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Attribute</th>
                    <th scope="col">Values</th>
                    {/* <th scope="col">
                    <div className="text-center">
                    <button className="btn btn-outline-primary"
                      onClick={handleCombinationSave}
                    >Save</button>
                </div>
                      
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {attributeList &&
                    attributeList.map((attribute, index) => (
                      <tr key={attribute.id}>
                        <th scope="row">{index + 1}</th>
                        <td>{attribute.name}</td>
                        <td className="row">
                          {attribute.values.map((value, index) => (
                            <div key={index} className="form-check col-md-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={value}
                                id={`attrcheckbox${value}`}
                                onChange={(e) =>
                                  handleValueCheck(
                                    e,
                                    attribute.name,
                                    attribute.id,
                                    value
                                  )
                                }
                              />
                              <label className="col-md-2">{value}</label>
                            </div>
                          ))}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {/* ------------------- Select Attribute Value Starts ----------------------*/}
              {!props.isEdit && (
                <div
                  className="btn btn-success btn-sm float-right"
                  onClick={handleSaveAttribute}
                >
                  Save
                </div>
              )}
            </div>

            <div
              className="tab-pane fade"
              id="v-pills-profile"
              role="tabpanel"
              aria-labelledby="v-pills-profile-tab"
            >
              {isEveryAttrSelected ? (
                <>
                  {combinations.length > 0 && (
                    <div className="text-right">
                      <button
                        className="btn btn-outline-info btn-sm m-2"
                        onClick={() => setVariantModal(true)}
                      >
                        Add Variant
                      </button>
                    </div>
                  )}
                  {showVariantModal && (
                    <Modal
                      show={showVariantModal}
                      modalClosed={() => setVariantModal(!showVariantModal)}
                    >
                      <div className="d-flex flex-wrap">
                        {combinations &&
                          combinations.map((cObj) => {
                            return (
                              !cObj.selected && (
                                <div className="card m-2">
                                  <div className="card-body">
                                    <div className="d-inline">
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          combinationSelect(e, cObj.variantId)
                                        }
                                      />
                                      <label className="ml-2">
                                        {" "}
                                        {createCombinationName(cObj.attributes)}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )
                            );
                          })}
                      </div>

                      <div className="text-center">
                        <button
                          className="btn btn-outline-primary"
                          onClick={handleCombinationSave}
                        >
                          Save
                        </button>
                      </div>
                    </Modal>
                  )}
                  {/* ------------------- Accordion Starts ----------------------*/}

                  {getAccordions()}

                  {/* ------------------- Accordion Ends ----------------------*/}
                </>
              ) : (
                <h4>Please Select All Attributes</h4>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-4">
        <button
          className="btn btn-primary"
          onClick={() => handleSubmitProduct()}
          disabled={props.singleSubmitLoading}
        >
          {props.singleSubmitLoading ? "Saving" : "Save Product"}
        </button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    attributes: state.attributes.attribute,
    singleSubmitLoading: state.products.singleSubmitLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAttribute: () => dispatch(actions.fetchAttribute()),
    onAddSingleProduct: (product) =>
      dispatch(actions.onAddSingleProduct(product)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(VariableProduct, Axios));
